import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories, getHotArticles, getNewArticles } from '@/mocks/articles';

export default function Home() {
  const hotArticles = getHotArticles();
  const newArticles = getNewArticles();
  const featuredArticle = articles[0];
  const secondaryFeatured = articles.slice(1, 3);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料不打烊',
    url: 'https://hqsls.cn',
    description: '黑料不打烊，24小时不间断为你推送最新、最劲爆的娱乐圈黑料、明星丑闻与网红爆料。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hqsls.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料不打烊',
    url: 'https://hqsls.cn',
    description: '全天候娱乐黑料聚合平台',
    sameAs: [
      'https://weibo.com/heiliaobudayang',
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[480px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20with%20vibrant%20red%20and%20amber%20stage%20spotlights%20piercing%20through%20dark%20atmosphere%2C%20mysterious%20silhouette%20of%20microphone%20stands%20and%20camera%20equipment%2C%20entertainment%20news%20and%20gossip%20vibe%2C%20dramatic%20theatrical%20lighting%2C%20rich%20deep%20shadows%20with%20warm%20highlights%2C%20no%20text%2C%20no%20watermark%2C%20abstract%20composition&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
              alt="黑料不打烊 - 娱乐黑料聚合平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-full text-center px-4 animate-fade-in">
                <h1
                  className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4"
                  style={{ fontFamily: "'ZCOOL QingKe HuangYou', cursive" }}
                >
                  黑料不打烊
                </h1>
                <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
                  24小时不间断为你推送最新、最劲爆的娱乐圈黑料、明星丑闻与网红爆料。无论深夜还是清晨，黑料不打烊始终在线，让你第一时间掌握圈内隐秘真相。
                </p>
                <div className="flex flex-wrap items-center justify-center gap-3">
                  {categories.slice(0, 6).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="px-5 py-2.5 rounded-full text-sm font-medium bg-white/15 backdrop-blur-sm text-white hover:bg-primary-500 transition-all duration-300 cursor-pointer whitespace-nowrap border border-white/20 hover:border-primary-500"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
          </section>

          {/* Main Content */}
          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
              {/* Left - Main Content */}
              <div className="flex-1 min-w-0">
                {/* Featured Article */}
                <section className="mb-10">
                  <div className="flex items-center gap-2 mb-5">
                    <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                    <h2 className="text-lg md:text-xl font-bold text-foreground-900">
                      头条爆料
                    </h2>
                  </div>
                  <ArticleCard
                    {...featuredArticle}
                    categoryName={categories.find((c) => c.slug === featuredArticle.category)?.name || ''}
                    variant="featured"
                  />
                </section>

                {/* Secondary Featured */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
                  {secondaryFeatured.map((article) => (
                    <ArticleCard
                      key={article.id}
                      {...article}
                      categoryName={categories.find((c) => c.slug === article.category)?.name || ''}
                    />
                  ))}
                </div>

                {/* Latest Articles */}
                <section className="mb-10">
                  <div className="flex items-center gap-2 mb-5">
                    <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                    <h2 className="text-lg md:text-xl font-bold text-foreground-900">
                      最新爆料
                    </h2>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {articles.filter(a => !a.isHot).slice(0, 6).map((article) => (
                      <ArticleCard
                        key={article.id}
                        {...article}
                        categoryName={categories.find((c) => c.slug === article.category)?.name || ''}
                      />
                    ))}
                  </div>
                </section>

                {/* All Articles */}
                <section>
                  <div className="flex items-center gap-2 mb-5">
                    <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                    <h2 className="text-lg md:text-xl font-bold text-foreground-900">
                      更多爆料
                    </h2>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {articles.slice(6).map((article) => (
                      <ArticleCard
                        key={article.id}
                        {...article}
                        categoryName={categories.find((c) => c.slug === article.category)?.name || ''}
                      />
                    ))}
                  </div>
                </section>
              </div>

              {/* Right - Sidebar */}
              <aside className="w-full lg:w-[340px] flex-shrink-0">
                <div className="sticky top-20">
                  {/* Hot Articles */}
                  <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 mb-6">
                    <div className="flex items-center gap-2 mb-4">
                      <i className="ri-fire-line text-accent-500 text-lg"></i>
                      <h3 className="text-base font-bold text-foreground-900">热门排行</h3>
                    </div>
                    <div className="space-y-1">
                      {hotArticles.map((article, index) => (
                        <ArticleCard
                          key={article.id}
                          {...article}
                          categoryName=""
                          variant="compact"
                        />
                      ))}
                    </div>
                  </div>

                  {/* Categories */}
                  <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 mb-6">
                    <h3 className="text-base font-bold text-foreground-900 mb-4">分类导航</h3>
                    <div className="flex flex-wrap gap-2">
                      {categories.map((cat) => (
                        <Link
                          key={cat.slug}
                          to={`/category/${cat.slug}`}
                          className="px-3 py-1.5 rounded-md text-xs font-medium bg-background-100 text-foreground-700 hover:bg-primary-500 hover:text-white transition-all cursor-pointer whitespace-nowrap"
                        >
                          {cat.name}
                        </Link>
                      ))}
                    </div>
                  </div>

                  {/* Subscribe */}
                  <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg p-5 text-white">
                    <h3 className="text-base font-bold mb-2">不错过任何瓜</h3>
                    <p className="text-sm text-white/80 mb-4">
                      关注黑料不打烊，第一时间接收最新爆料推送
                    </p>
                    <a
                      href="#"
                      className="block text-center px-4 py-2.5 rounded-md bg-white/20 hover:bg-white/30 text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                      rel="nofollow"
                    >
                      立即关注
                    </a>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}